/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
// console.log("Hello World! (from ultime-blocks-stuck-pixel-en block)");
/* eslint-enable no-console */
(function () {
    const colors = [
        { name: 'Black', hex: '#000000', textColor: '#ffffff' },
        { name: 'White', hex: '#FFFFFF', textColor: '#000000' },
        { name: 'Red', hex: '#FF0000', textColor: '#ffffff' },
        { name: 'Green', hex: '#00FF00', textColor: '#000000' },
        { name: 'Blue', hex: '#0000FF', textColor: '#ffffff' },
        { name: 'Cyan', hex: '#00FFFF', textColor: '#000000' },
        { name: 'Magenta', hex: '#FF00FF', textColor: '#ffffff' },
        { name: 'Yellow', hex: '#FFFF00', textColor: '#000000' },
        { name: 'Gray', hex: '#808080', textColor: '#ffffff' }
    ];

    let currentColorIndex = 0;
    let controlsVisible = true;
    let isDraggingControls = false;
    let controlsOffsetX = 0;
    let controlsOffsetY = 0;

    const app = document.getElementById('app');
    const colorDisplay = document.getElementById('colorDisplay');
    const colorInfo = document.getElementById('colorInfo');
    const colorIndicator = document.getElementById('colorIndicator');
    const controls = document.getElementById('controls');
    const toggleHint = document.getElementById('toggleHint');
    const fullscreenBtn = document.getElementById('fullscreenBtn');
    const hideControlsBtn = document.getElementById('hideControlsBtn');
    const prevBtn = document.getElementById('prevBtn');
    const nextBtn = document.getElementById('nextBtn');

    function showColor(index) {
        currentColorIndex = index;
        const color = colors[currentColorIndex];
        colorDisplay.style.backgroundColor = color.hex;
        colorInfo.textContent = `Color: ${color.name} (${color.hex})`;
        colorIndicator.textContent = color.name.toUpperCase();
        colorIndicator.style.color = color.textColor;
        colorIndicator.classList.add('show');
        setTimeout(() => colorIndicator.classList.remove('show'), 1000);
    }

    function nextColor() {
        currentColorIndex = (currentColorIndex + 1) % colors.length;
        showColor(currentColorIndex);
    }

    function prevColor() {
        currentColorIndex = (currentColorIndex - 1 + colors.length) % colors.length;
        showColor(currentColorIndex);
    }

    function toggleControls() {
        controlsVisible = !controlsVisible;
        controls.classList.toggle('controls-hidden', !controlsVisible);
        toggleHint.style.opacity = controlsVisible ? '0.8' : '0';
        hideControlsBtn.textContent = controlsVisible ? 'Masquer contrôles' : 'Afficher contrôles';
    }

    function toggleFullscreen() {
        if (!document.fullscreenElement) {
            app.requestFullscreen().catch(err => console.error(err));
        } else {
            document.exitFullscreen();
        }
    }

    function updateFullscreenButton() {
        const isFs = !!document.fullscreenElement;
        fullscreenBtn.textContent = isFs ? 'Quitter plein écran' : 'Plein écran';
        // Réinitialiser la position des contrôles en quittant le plein écran
        if (!isFs) {
            controls.style.left = '';
            controls.style.top = '';
        }
    }

    prevBtn.addEventListener('click', prevColor);
    nextBtn.addEventListener('click', nextColor);
    fullscreenBtn.addEventListener('click', toggleFullscreen);
    hideControlsBtn.addEventListener('click', toggleControls);

    colorDisplay.addEventListener('click', (e) => {
        if (e.target === colorDisplay) nextColor();
    });

    document.addEventListener('keydown', (e) => {
        switch (e.key) {
            case 'ArrowRight': case ' ':
                e.preventDefault(); nextColor(); break;
            case 'ArrowLeft':
                e.preventDefault(); prevColor(); break;
            case 'h': case 'H':
                e.preventDefault(); toggleControls(); break;
            case 'f': case 'F':
                e.preventDefault(); toggleFullscreen(); break;
            case 'Escape':
                if (document.fullscreenElement) document.exitFullscreen(); break;
        }
    });

    document.addEventListener('fullscreenchange', updateFullscreenButton);

    // Drag uniquement en plein écran
    controls.addEventListener('mousedown', (e) => {
        if (!document.fullscreenElement) return;
        if (e.target.tagName === 'BUTTON') return;
        isDraggingControls = true;
        const rect = controls.getBoundingClientRect();
        controlsOffsetX = e.clientX - rect.left;
        controlsOffsetY = e.clientY - rect.top;
        controls.style.cursor = 'grabbing';
    });

    document.addEventListener('mousemove', (e) => {
        if (!isDraggingControls) return;
        const newLeft = e.clientX - controlsOffsetX;
        const newTop = e.clientY - controlsOffsetY;
        const maxX = app.offsetWidth - controls.offsetWidth;
        const maxY = app.offsetHeight - controls.offsetHeight;
        controls.style.left = Math.max(0, Math.min(newLeft, maxX)) + 'px';
        controls.style.top = Math.max(0, Math.min(newTop, maxY)) + 'px';
    });

    document.addEventListener('mouseup', () => {
        if (isDraggingControls) {
            isDraggingControls = false;
            controls.style.cursor = document.fullscreenElement ? 'move' : 'default';
        }
    });

    let touchStartX = 0;
    colorDisplay.addEventListener('touchstart', (e) => { touchStartX = e.touches[0].clientX; });
    colorDisplay.addEventListener('touchend', (e) => {
        const diff = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 50) diff > 0 ? nextColor() : prevColor();
    });

    setTimeout(() => { toggleHint.style.opacity = '0'; }, 5000);
    toggleHint.addEventListener('mouseenter', () => { toggleHint.style.opacity = '0.8'; });

    showColor(0);
})(

);